import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CalculatorContext } from '../Context/CalculatorContext'
import RemoveBlockButton from '../Calculator/RemoveBlockButton'
import Block from '../Block'
import Slider from '../Slider'
import sliders from '../../templates/sliders'
import { calculateRestoreCost } from '../../model/calculator/calculator'

const RestoreBlock = ({ cost, setCost, setShowBlock }) => {
    const [restore, setRestore] = useState(0)
    const { currency } = useContext(CalculatorContext)

    useEffect(() => {
        setCost(calculateRestoreCost(restore))
    }, [restore, setCost, currency])

    const handleRemoveBlock = () => {
        setCost(0)
        setShowBlock(false)
    }

    return (
        <Block
            currency={currency}
            cost={cost}
            title={'Restore'}
            startOpen={true}
        >
            <RemoveBlockButton onClick={handleRemoveBlock} />

            <Slider
                {...sliders.restore}
                value={restore}
                onChange={setRestore}
            />
        </Block>
    )
}

RestoreBlock.propTypes = {
    cost: PropTypes.number.isRequired,
    setCost: PropTypes.func.isRequired,
    setShowBlock: PropTypes.func.isRequired
}

export default RestoreBlock
